import clsx from 'clsx'
import { Icon } from '@iconify/react'

import s from './ViewToggleBtn.module.css'

interface ViewToggleBtnProps {
  showDataView: View
  setShowDataView?: React.Dispatch<React.SetStateAction<View>>
  disabledView?: View
  isDisabled?: boolean
}

const ViewToggleBtn = ({
  showDataView,
  setShowDataView,
  disabledView,
  isDisabled = false,
}: ViewToggleBtnProps): JSX.Element => {
  return (
    <>
      <div className={s.iconView}>
        <button
          className={clsx(s.viewTypeButton, {
            [s.selectedButton]: showDataView === 'grid',
            [s.disabled]: isDisabled || disabledView === 'grid',
          })}
          data-id="pv_cardView"
          onClick={(): void => setShowDataView?.('grid')}
          title="Switch to grid view"
          disabled={isDisabled}
        >
          <Icon
            icon="material-symbols:grid-view-outline-rounded"
            width={14}
            height={24}
          />
        </button>
        <button
          className={clsx(s.viewTypeButton, {
            [s.selectedButton]: showDataView === 'list',
            [s.disabled]: isDisabled || disabledView === 'list',
          })}
          data-id="pv_horizontalView"
          onClick={(): void => setShowDataView?.('list')}
          title="Switch to list view"
          disabled={isDisabled}
        >
          <Icon
            icon="material-symbols:format-list-bulleted-rounded"
            width={14}
            height={24}
          />
        </button>
      </div>
    </>
  )
}

export default ViewToggleBtn
